import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { RxDashboard } from "react-icons/rx";
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
import { IoCreateOutline } from "react-icons/io5";
import { CiCircleAlert, CiBank, CiSettings } from "react-icons/ci";
import { LuWarehouse } from "react-icons/lu";
import { TbReport } from "react-icons/tb";
import { GoMilestone } from "react-icons/go";
import { MdSupportAgent } from "react-icons/md";
import { MdGroups2 } from "react-icons/md";
import { RiGroupLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { useMyContext } from "../../../context/MyContext";
import '../../../css/custom-scrollbar.css';
import { useAuth } from '../../../routes/Auth'
import { LogOut } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GiBrain } from "react-icons/gi";


const Sidebar = () => {
  const { profile_flag } = useMyContext();
  const [activeTab, setActiveTab] = useState(-1);
  const [pageTab, setPageTab] = useState(-1);
  const [activeSubTab, setActiveSubTab] = useState(-1);
  const { isToggleSidebar, setIsToggleSidebar, isDarkMode,toggleB2BMode } = useMyContext();
  const navigate = useNavigate();
  const { logout } = useAuth()
  const sidebarRef = useRef(null)
  const userRole = localStorage.getItem("role");

  const toggleSubmenu = useCallback(
    (index, href) => {
      if (profile_flag === "0" && userRole !== "admin") {
        toast.error("Please Contact to the Support Team, Your KYC is Pending");
        return;
      }
      if (href) {
        navigate(href);
        // setIsToggleSidebar(false);
      } else {
        setActiveTab((prevActiveTab) => (prevActiveTab === index ? null : index));
      }
    },
    [profile_flag, userRole, navigate, setActiveTab]
  );

  let menuItems = [
    {
      title: "Dashboard",
      icon: <RxDashboard />,
      href: "/b2b/dashboard",
      submenu: [],
    },
    {
      title: "Shipments",
      icon: <IoCreateOutline />,
      submenu: [
        { title: "Forward Shipment", href: "/b2b/shipments/forward" },
        // { title: "Reverse Shipment", href: "/b2b/shipments/reverse" },
        // { title: "Bulk Upload List", href: "/b2b/shipment/bulkUpload" },
        { title: "Track Shipments", href: "/b2b/shipment/track" },
        { title: "View Shipments", href: "/b2b/shipments/list" },
        { title: "Pickup Request", href: "/b2b/shipment/pickuprequest" },
        ,

      ],
    },
    {
      title: "Warehouse",
      icon: <LuWarehouse />,
      submenu: [
        { title: "Add Warehouse", href: "/b2b/warehouse/add" },
        { title: "All Warehouses", href: "/b2b/warehouse/all" },
      ],
    },
    // {
    //   title: "Intregation",
    //   icon: <CiCircleAlert />,
    //   submenu: [
    //     { title: "Sopify", href: "/b2b/intregration/sopify" },
    //   ],
    // },
    // {
    //   title: "Disputes",
    //   icon: <CiCircleAlert />,
    //   submenu: [
    //     { title: "NDR", href: "/b2b/disputes/NDR" },
    //     { title: "Weight Disputes", href: "/b2b/disputes/weight" },
    //     { title: "Weight Upload", href: "/b2b/disputes/wightUpload" },
    //     { title: "All Weight Disputes", href: "/b2b/disputes/allWeightDisputes" },
    //   ],
    // },
    {
      title: "Payments",
      icon: <CiBank />,
      submenu: [
        { title: "Wallet Balance", href: '/b2b/payments/wallet_recharge' },
      ],
    },
    // {
    //   title: "Services",
    //   icon: <GoMilestone />,
    //   href: "/services",
    //   submenu: [],
    // },
    {
      title: "Customers",
      icon: <RiGroupLine />,
      submenu: [
        { title: "ViewAllCustomer", href: "/b2b/customers/viewCustomer" },
        { title: "KYC Pending", href: "/b2b/customers/kycPending" },
      ],
    },
    {
      title: "Preship",
      icon: <GiBrain />,
      submenu: [
        { title: "Rate Calculator", href: "/b2b/preship/PriceEstimator" },
        // { title: "Servicable Pincodes", href: "/b2b/settings/pincode" },
        { title: "Rate Card", href: "/b2b/preship/rateCard/" },
        { title: "Set Rate", href: "/b2b/preship/setRate" },
      ],
    },
    {
      title: "Reports",
      href: "/b2b/reports",
      icon: <TbReport />,
      submenu: [],
    },
    {
      title: "Help",
      href: "/b2b/help",
      icon: <MdSupportAgent />,
      submenu: [],
    },
    {
      title: "Setting",
      icon: <CiSettings />,
      submenu: [
        { title: "Add Employee", href: "b2b/addEmployee" },
        { title: "All Employee", href: "b2b/allEmployee" },
      ],
    },
    {
      title: "Profile",
      icon: <CgProfile />,
      href: "/b2b/profile",
      submenu: [],
    },
  ];

  if (userRole !== "admin") {
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Disputes") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Weight Upload");
      }
      if (item.submenu && item.title === "Disputes") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "All Weight Disputes");
      }
    });
    menuItems = menuItems.filter(item => item.title !== "Customers");
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Preship") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Set Rate");
      }
    });
    menuItems = menuItems.filter(item => item.title !== "Setting");
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Add Role") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Add Role");
      }
    });
  } else {
    menuItems.forEach(item => {
      if (item.submenu && item.title === "Preship") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Rate Card");
      }
      if (item.submenu && item.title === "Preship") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Rate Calculator");
      }
      if (item.submenu && item.title === "Disputes") {
        item.submenu = item.submenu.filter(subItem => subItem.title !== "Weight Disputes");
      }
    });
  }

  useMemo(() => {
    let currRoute = window.location.pathname
    menuItems.map((item, index) => {
      if (item.href && currRoute == item.href) {
        setActiveTab(index);
        setPageTab(index);
      }
      if (item.submenu) {
        item.submenu.map((subItem, subIndex) => {
          if (subItem.href && currRoute == subItem.href) {
            setActiveTab(index);
            setActiveSubTab(subIndex);
            setPageTab(index);
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth <= 768
      ) {
        setIsToggleSidebar(false);
      }
    };
    if (isToggleSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, [isToggleSidebar, setIsToggleSidebar]);



  const handleLogout = () => {
    toggleB2BMode(false)
    localStorage.removeItem("user");
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
    toast.success("LogOut Sucessfully!")
    window.location.reload();
  }

  return (
    <>
      <ToastContainer />
      {isToggleSidebar && (
        <div ref={sidebarRef} className="w-64 h-full flex flex-col  transform transition-transform duration-300 pl-2 custom-scrollbar ">
          <ul className="flex-1">
            {menuItems.map((item, index) => (
              <li key={index}>
                <Button
                  sx={{
                    fontFamily: 'var(--font-custom-open-sans)',
                    textTransform: 'none',
                    color: isDarkMode ? 'white' : 'rgba(6, 6, 6, 0.616)',
                    width: '100%',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    display: 'flex',
                    // paddingLeft:'1.5rem',
                    alignItems: 'center',
                    padding: '0.75rem 1rem',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      backgroundColor: 'rgba(128,128,128, 0.3)',
                      color: isDarkMode ? 'white' : 'rgba(6, 6, 6, 0.616)',
                      boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
                      transform: 'scale(1.05)',
                    },
                  }}
                  onClick={() => toggleSubmenu(index, item.href)}
                >
                  <span className={activeTab == index ? "icon mr-2 text-xl text-emerald-600 " : "icon mr-2 text-xl text-emerald-400 "}>
                    {item.icon}
                  </span>
                  <span className="pl-3x">
                    {item.title}
                  </span>
                  <span
                    className="arrow ml-auto"
                  >
                    {item.submenu.length ? (activeTab === index ? <FaAngleDown /> : <FaAngleRight />) : ""}
                  </span>
                </Button>
                {item.submenu.length > 0 && activeTab === index && (
                  <div className="submenuWrapper pl-6">
                    <ul className="submenu text-custom-gray border-l pl-4 border-gray-600">
                      {item.submenu.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          className={`py-1 px-1 dark:text-white ${activeTab === index && activeSubTab === subIndex
                            ? "text-customPurple font-bold dark:text-gray-700"
                            : "text-gray-700 font-bold dark:text-customPurple"
                            }`}
                        >
                          <Link
                            to={subItem.href}
                            className="text-sm font-semibold hover:opacity-70 hover:text-customPurple transition-opacity duration-300"
                            aria-label={subItem.title}
                            style={{
                              fontFamily: 'var(--font-custom-open-sans)',
                              color: isDarkMode ? (pageTab === index && activeSubTab === subIndex ? '#A76EDB' : 'black') : (activeTab === index && activeSubTab === subIndex ? '#A76EDB' : 'rgba(6, 6, 6, 0.616)'),
                            }}
                          >
                            {subItem.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>
          <div className="bg-blue-200 p-6 rounded-lg shadow-md  md:mt-8 md:mb-10 mt-8 mb-10 relative">
            <button
              onClick={handleLogout}
              className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white font-sans font-medium py-2 px-4 ml-7 rounded-md transition duration-300 ease-in-out w-28"
            >
              <LogOut className="mr-2 h-4 w-4" />
              LogOut
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
